export const PERSON = 1;
export const COMPANY = 2;